import { PaymentPlansUI } from "./PaymentPlansUI";
import { getPaymentPlansView } from "./getPaymentPlansView";
import { createPaymentPlansAnalytics } from "./analytics";
import { StandardProps } from "../componentMap";
import { useVariant } from "@/hooks/useVariant/useVariant";

export function PaymentPlans({
  product,
  creditOffersV2,
  flags,
  runtimeConfig,
}: Pick<
  StandardProps,
  "product" | "creditOffersV2" | "flags" | "runtimeConfig"
>) {
  const { variant, isSelected } = useVariant(product);

  if (!flags.showPaymentPlans.value) return null;

  const view = getPaymentPlansView({
    product,
    creditOffersV2: creditOffersV2 ?? [],
    variant,
    isSelected,
  });

  if (view.kind === "hidden") return null;

  return (
    <PaymentPlansUI
      view={view}
      runtimeConfig={runtimeConfig}
      analytics={createPaymentPlansAnalytics(product, variant)}
    />
  );
}
